import React from 'react';
import StandardAIDetail from './StandardAIDetail';

// Custom template for Clinical Intelligence - can be customized later
const ClinicalIntelligenceDetail = ({ card }) => {
  // For now, use the standard template
  // You can customize this component with specific UI for Clinical Intelligence
  return <StandardAIDetail card={card} />;
};

export default ClinicalIntelligenceDetail;
